import {
  CreateCategoriesRequest,
  i18nResponseDto,
  ProductDetailsResponseDto,
  TagRequest,
} from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';

// TODO: Yes, this function is also defined in:
// useEditProduct/generateProductPayload/helpers.ts
//
// This is duplicated but we can keep it here for now.
// I want to keep the code DRY but since we're still iterating
// on this project, I don't want to get ahead of myself.
export function getAttributes(
  language: LanguagesType,
  attributes: i18nResponseDto[],
): i18nResponseDto[] {
  return attributes.map((attribute) => ({
    ...attribute,
    default: attribute[language],
  }));
}
export function getTags(tags: string | undefined): TagRequest[] {
  if (!tags) return [];
  return tags.split(',').map((tag) => ({
    tag: tag.trim(),
  }));
}

export function getCategories(
  categories: string[] | undefined,
): CreateCategoriesRequest[] {
  if (!categories) return [];
  return categories.map((category, index) => ({
    id: Number(category),
    order: index,
  }));
}

export function createResponseDto(
  createdId: number,
): ProductDetailsResponseDto {
  return { id: createdId } as unknown as ProductDetailsResponseDto;
}
